import { GxIcon } from '@garpix/garpix-web-components-react'
import React, { useState } from 'react'
import { questionIcon } from '@/images'
import style from '../styles/game_detail.module.scss'
import classNames from 'classnames'

const Accordion = ({ title = '', answer = '' }): React.ReactElement => {
  const [opened, setOpened] = useState(false)

  const handleToggleOpen = (): void => {
    setOpened(!opened)
  }

  return (
    <div className={style.accordion}>
      <button
        type='button'
        className={classNames({
          [style.accordion__title]: true,
          [style['accordion__title--opened']]: opened
        })}
        onClick={handleToggleOpen}
      >
        <GxIcon
          src={questionIcon}
          className={classNames({
            [style.accordion__icon]: true,
            [style['accordion__icon--opened']]: opened
          })}
        />
        {title}
      </button>
      <p
        className={classNames({
          [style.accordion__text]: true,
          [style['accordion__text--opened']]: opened
        })}
      >
        {answer}
      </p>
    </div>
  )
}

export default Accordion
